/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Added by Jasmin H at Shopify Theme Support on Apr 25, 2022
var sections = window.theme.sections;

var cartExtension = {
  init: function () {
    this.on(
      'cart_update_done',
      this._updateCartCount.bind(this)
    );
  },

  _updateCartCount: function (e, i, cart) {
    $('.site-header__cart-bubble').text(cart.item_count);
  }
};

sections.extend('cart-drawer', cartExtension);
sections.extend('cart-template', cartExtension);
// End of code by Jasmin H at Shopify - Theme Support